import * as yup from "yup";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";

export type AdditionalInformationFormProps = {
    id: string;
    returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: AdditionalInformationFormInput;
    action: "post" | "put";
};

export type AdditionalInformationFormInput = {
    additionalInformationId:number;
    applicationId:number;
    applicationInspectionId: number;
    unobstructedAreaComplianceId:number;
    unobstructedAreaCompliance?: ComplianceOptions;
    unobstructedAreaComment:string;
    stormwaterRunoffComplianceId:number;
    stormwaterRunoffCompliance?: ComplianceOptions;
    stormwaterRunoffComment:string;
    alarmComplianceId:number;
    alarmCompliance?: ComplianceOptions;
    alarmComment:string;
    supportDocumentComplianceId: number;
    supportDocumentCompliance?: ComplianceOptions;
    supportDocumentnComment:string;
    buildingAreaComplianceId:number;
    buildingAreaCompliance?: ComplianceOptions;
    buildingAreaComment:string;
    sitePlanComplianceId:number;
    sitePlanCompliance?: ComplianceOptions;
    sitePlanComment:string;
    finalSiteGradeComplianceId:number;
    finalSiteGradeCompliance? : ComplianceOptions;
    finalSiteGradeComment:string;
    contractorComplianceId:number;
    contractorCompliance?: ComplianceOptions;
    contractorComment:string;
    ehdcontactId: number;
    dateCreated: Date|string;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    inspectionStatusId: number;
    ehdcontactName?: string;
    markAll: number;

    contractor? : ContractorDto;
    
};

// export type AdditionalInformationSubmitInput = Omit<AdditionalInformationFormInput, "contractorId"> &  {
//     contractorId: number;
// }
export type ComplianceData = {
    id: string;
    name: string;
};
export type ContractorDto = {
  contractorId : number;
  ehdcontactId : number;
  firstName: string;
  middleName: string;
  lastName: string;
  organization: string;
  title: string;
};
export type ContractorData = {
    id: string;
    name:string;
};

export const schema = yup.object().shape({
    unobstructedAreaComplianceId: yup
    .number()
    .min(1, "Unobstructed Area Compliance is required")
    .required("Unobstructed Area Compliance is required")
    .typeError("Unobstructed Area Compliance is required"),
    unobstructedAreaComment: yup.string().nullable(true)
    .when("surfaceWaterComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Surface Water Comment is required")
      .typeError("Surface Water Comment is required"),
    }),
    stormwaterRunoffComplianceId: yup
    .number()
    .min(1, "Storm Water Runoff Compliance is required")
    .required("Storm Water Runoff Compliance is required")
    .typeError("Storm Water Runoff Compliance is required"),
    stormwaterRunoffComment: yup.string().nullable(true)
    .when("stormwaterRunoffComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Storm Water Runoff Comment is required")
      .typeError("Storm Water Runoff Comment is required"),
    }),
    alarmComplianceId: yup
    .number()
    .min(1, "Alarm Compliance is required")
    .required("Alarm Compliance is required")
    .typeError("Alarm Compliance is required"),
    alarmComment: yup.string().nullable(true)
    .when("alarmComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Alarm Comment is required")
      .typeError("Alarm Comment is required"),
    }),
    supportDocumentComplianceId: yup
    .number()
    .min(1, "Support Document Compliance is required")
    .required("Support Document Compliance is required")
    .typeError("Support Document Compliance is required"),
    supportDocumentnComment: yup.string().nullable(true)
    .when("supportDocumentComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Support Document Comment is required")
      .typeError("Support Document Comment is required"),
    }),
    buildingAreaComplianceId: yup
    .number()
    .min(1, "Building Area Compliance is required")
    .required("Building Area Compliance is required")
    .typeError("Building Area Compliance is required"),
    buildingAreaComment: yup.string().nullable(true)
    .when("buildingAreaComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Building Area Comment is required")
      .typeError("Building Area Comment is required"),
    }),
    sitePlanComplianceId: yup
    .number()
    .min(1, "Compliance with Site Plan is required")
    .required("Compliance with Site Plan is required")
    .typeError("Compliance with Site Plan is required"),
    sitePlanComment: yup.string().nullable(true)
    .when("sitePlanComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Compliance with Site Plan Comment is required")
      .typeError("Compliance with Site Plan Comment is required"),
    }),
    finalSiteGradeComplianceId: yup
    .number()
    .min(1, "Final Site Grade Compliance is required")
    .required("Final Site Grade Compliance is required")
    .typeError("Final Site Grade Compliance is required"),
    finalSiteGradeComment: yup.string().nullable(true)
    .when("finalSiteGradeComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Final Site Grade Comment is required")
      .typeError("Final Site Grade Comment is required"),
    }),
    contractorComplianceId: yup
    .number()
    .min(1, "Contractor Compliance is required")
    .required("Contractor Compliance is required")
    .typeError("Contractor Compliance is required"),
    contractorComment: yup.string().nullable(true)
    .when("contractorComplianceId", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string()
      .required("Contractor Comment is required")
      .typeError("Contractor Comment is required"),
    }),
    ehdcontactId: yup.number().nullable(true)
    .when("contractorComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
    .min(1, "Contractor Id is required")
    .typeError("Contractor Id is required")
    .required("Contractor Id is required"),
    }),
});